import cloneDeep from 'lodash/cloneDeep';

import type { Chart, ChartData } from '@webapp/account/src/resources/survey/chart';
import { initialChartData } from '@webapp/account/src/resources/survey/chart';
import type { Folder } from '@webapp/account/src/resources/survey/folder';

import { ChartGrouping } from '@webapp/common/lib/date';
import type { Language } from '@webapp/common/resources/entities/language';

import type { Survey } from './survey';

export interface ShareLink {
    id?: number;
    surveyId?: number;
    title: string | null;
    rewrite: string | null;
    active: boolean;
    passwordAccess: boolean;
    password: string | null;
    reports: boolean;
    answers: boolean;
    download: boolean;
    filters: boolean;
    crossTab: boolean;
    comparison: boolean;
    common?: boolean;
    surveyResults?: boolean;
    filterGroupId?: number;
}

export const initialShareLink: ShareLink = {
    title: '',
    rewrite: '',
    active: true,
    passwordAccess: true,
    password: '',
    reports: false,
    answers: false,
    download: false,
    filters: false,
    crossTab: false,
    comparison: false,
    filterGroupId: null,
};

export interface SurveyState {
    // TODO use root Folder
    folders: Array<Folder>;
    visibleCount: number;
    expandedFolderId: number;

    countWithoutFolder: number;

    activeSurveyId: number;
    items: Array<Survey>; // TODO use map by id

    search: string;
    paginationPage: number;

    chartData: ChartData;
    charts: Array<Chart>;
    chartGrouping: ChartGrouping;

    saveParams: boolean;
    fetchItems: boolean;
    fetchFolders: boolean;
    foldersLoaded: boolean;
    fetchStat: boolean;

    // /account/getFile/:id
    fileLink: string;

    // /account/copy-template/:id
    copiedTemplateId: number;

    deleteFiles: boolean;
    shareLinks: Array<ShareLink>;
    shareLinksSurveyId?: number;

    isAllLanguagesLoaded: boolean;
    allLanguages: Array<Language>;
}

export const initialState: Readonly<SurveyState> = {
    folders: [],
    visibleCount: 0,
    expandedFolderId: null,
    countWithoutFolder: 0,
    activeSurveyId: null,
    items: [],
    search: '',
    paginationPage: 1,
    chartData: cloneDeep(initialChartData),
    charts: [],
    chartGrouping: ChartGrouping.DAY,
    saveParams: false,
    fetchItems: true,
    fetchFolders: true,
    foldersLoaded: false,
    fetchStat: false,
    fileLink: null,
    copiedTemplateId: null,
    deleteFiles: false,
    shareLinks: [],
    isAllLanguagesLoaded: false,
    allLanguages: [],
};
